<script lang="ts">
	import { Button, Container, Text, Stack } from '@Shelly/shelly-design-system';
	import { capFirstChar } from '../../../../../helpers/utilities';
	import { createEventDispatcher } from 'svelte';
	import { format } from '../../../../../services/i18n';
	import ActionPreviewWithControls from '../../../components/GenericView/ActionPreviewWithControls.svelte';
	import SectionContainer from 'src/components/Scenes/components/GenericView/SectionContainer.svelte';
	import { normalizeSceneDoStatements } from '../../../../Flows/converters/flow-island-utils';

	export let thens = [];

	const dispatch = createEventDispatcher();

	const handle_event = (e, event_type: 'edit' | 'delete' = 'edit', ind = -1) => {
		e.stopPropagation();
		dispatch(event_type, { type: 'action', ind });
	};

	$: list = normalizeSceneDoStatements(thens);
</script>

<Container padding="scrollPaddings">
	<Text styleType="h2" class="mb-s">{capFirstChar($format('scene_preview_do'))}</Text>
	<Stack gap="s" class="d-flex flex-direction-column">
		{#key list}
			{#each list as element, ind (element)}
				<SectionContainer>
					<ActionPreviewWithControls
						{element}
						type={'action'}
						{ind}
						on:edit={(e) => handle_event(e, 'edit', ind)}
						on:delete={(e) => handle_event(e, 'delete', ind)}
					/>
				</SectionContainer>
			{/each}
		{/key}
	</Stack>

	<div class="mt-m text-center">
		<Button
			variant="secondary"
			size="m"
			on:click={(e) => {
				e.stopPropagation();
				dispatch('add', { type: 'action', ind: -1 });
			}}
		>
			{$format('button_add_card', {
				default: 'Add card',
			})}
		</Button>
	</div>
</Container>
